export default "__VITE_ASSET__6f0sc0HA__"